import { Control, Controller, useWatch } from "react-hook-form";

import { FormLabel } from "@ui/FormElements";
import { ICreateDealForm, SourcePeopleSelect } from "@components/AddNewEntity/Deal";

interface ISourcePersonFormFieldProps {
  control: Control<ICreateDealForm>;
}

export function SourcePersonFormField({ control }: ISourcePersonFormFieldProps) {
  const sourceCompany = useWatch({ control, name: "source_company" });

  return (
    <Controller
      control={control}
      name="source_people"
      render={({ field: { value, onChange } }) => (
        <div>
          <FormLabel htmlFor="source_people" className="!mb-1.5">Source Person</FormLabel>
          <SourcePeopleSelect
            value={value}
            onChange={onChange}
            placeholder="Select people"
            companyId={sourceCompany?.value}
          />
        </div>
      )}
    />
  );
}
